
import { RouteConfig } from './types';
import ContactsPage from '../pages/contacts/ContactsPage';
import ContactDetailPage from '../pages/contacts/ContactDetailPage';

export const contactRoutes: RouteConfig[] = [
  { path: "/app/contacts", element: ContactsPage, requiresLayout: true },
  { path: "/contacts", element: ContactsPage, requiresLayout: true },
  { path: "/app/contacts/:id", element: ContactDetailPage, requiresLayout: true },
  { path: "/contacts/:id", element: ContactDetailPage, requiresLayout: true }
];
